import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';
import { useToast } from '@getaccept/lib-shared/src/toast';
import { SearchService } from '@getaccept/lib-shared/src/search/services/search.service';
import type { SearchResult } from '../types/search-result';

export const useSearchStore = defineStore('search', () => {
  const loading = ref(false);
  const loaded = ref(false);
  const isSeachVisible = ref(false);
  const query = ref('');
  const result = ref<SearchResult>({ documents: [], contacts: [] });
  const { toast } = useToast();

  const search = async ({
    searchQuery,
    showAll,
    showTeam,
  }: {
    searchQuery: string;
    showAll?: boolean;
    showTeam?: boolean;
  }) => {
    loaded.value = false;
    loading.value = true;
    query.value = searchQuery;
    try {
      const resultData = await SearchService.search(searchQuery, showAll, showTeam);
      const documents = resultData.documents ? resultData.documents : [];
      const contacts = resultData.contacts ? resultData.contacts : [];
      const searchResult: SearchResult = { documents, contacts };
      result.value = searchResult;
      loaded.value = true;
    } catch (error) {
      toast.danger('failed-to-retrieve-search-results');
      loading.value = false;
    } finally {
      loading.value = false;
    }
  };

  const showSearchInput = (show: boolean) => {
    isSeachVisible.value = show;
  };

  const clearData = () => {
    loading.value = false;
    loaded.value = false;
    isSeachVisible.value = false;
    query.value = '';
    result.value = { documents: [], contacts: [] };
  };

  return {
    loading,
    loaded,
    isSeachVisible,
    query,
    result,
    search,
    showSearchInput,
    clearData,
  };
});
